module.exports = __webpack_public_path__ + "assets/img/00029.c937c1c6.png";